export const cultureCircleDefaultMemory = {
  sneakers: {
    behavioral: {
      preferences: {
        visual: {
          ankle_support: "none",
          breathability: "high",
          heel_height: "low",
          primary_material: "mesh",
          color: "primary",
          cushioning_level: "medium",
          style_type: "athletic",
          sole_type: "rubber",
          sneaker_shape: "low-top",
          texture: "mesh",
          material: "mesh",
          embellishments: "laces",
          closure_type: "lace-up",
          pattern: "abstract",
          ismulticolor: "true",
          silhouette: "straight",
          design_elements: "panels",
          texture_detail: "smooth",
          length_variation: "regular",
          lace_style: "round",
          sole_design: "cushioned",
          toe_shape: "round",
          contrast_stitching: "black",
          breathable_mesh: "true",
          reflective_detailing: "false",
          translucent_panels: "false",
          embellishment_type: "prints",
        },
      },
    },
  },

  hoodies: {
    behavioral: {
      preferences: {
        visual: {
          embellishment_type: "prints",
          silhouette: "oversized",
          design_elements: "print",
          texture_detail: "smooth",
          length_variation: "regular",
          fabric_sheen: "matte",
          seam_detail: "double-stitched",
          drawstring_detail: "flat",
          hood_length: "medium",
          pocket_style: "kangaroo",
          sleeve_cuff: "fitted",
          zipper_type: "no zipper",
          pattern: "solid",
          material: "cotton",
          primary_material: "cotton",
          ismulticolor: "false",
          color: "primary",
          color_contrast: "low",
          drape_quality: "medium",
          print_type: "graphic",
        },
      },
    },
  },
  sunglasses: {
    behavioral: {
      preferences: {
        visual: {
          bridge_type: "single",
          frame_style: "cat-eye",
          lens_shape: "cat-eye",
          rim_detail: "full-rim",
          temple_design: "smooth",
          material: "acetate",
          primary_material: "acetate",
          ismulticolor: "false",
          color: "primary",
        },
      },
    },
  },
  "t-shirts": {
    behavioral: {
      preferences: {
        visual: {
          silhouette: "oversized",
          sleeve_length: "short",
          design_elements: "print",
          texture_detail: "smooth",
          length_variation: "regular",
          hem_style: "straight",
          neckline_shape: "crew",
          color_contrast: "high",
          drape_quality: "medium",
          fabric_sheen: "matte",
          print_type: "graphic",
          seam_detail: "double-stitched",
          fit_type: "relaxed",
          graphic_placement: "front",
          material: "cotton",
          primary_material: "cotton",
          ismulticolor: "false",
          color: "primary",
          embellishment_type: "prints",
          pattern: "striped",
        },
      },
    },
  },
  sweaters: {
    behavioral: {
      preferences: {
        visual: {
          neckline_style: "crew",
          silhouette: "oversized",
          design_elements: "print",
          texture_detail: "smooth",
          length_variation: "regular",
          sleeve_design: "long",
          color_contrast: "medium",
          drape_quality: "medium",
          fabric_sheen: "matte",
          print_type: "graphic",
          hemline_shape: "straight",
          pattern: "watercolor",
          material: "cotton",
          primary_material: "cotton",
          ismulticolor: "false",
          color: "primary",
          embellishment_type: "prints",
          seam_detail: "double-stitched",
          cuff_detail: "ribbed",
          knit_pattern: "basketweave",
        },
      },
    },
  },
};
